import React from "react";
import {Pane} from "evergreen-ui";
import RiverFloodPage from "./RiverFloodPage";

export default function ConstructorRiverFlood() {

    return (
        <Pane margin={40}>
            <RiverFloodPage isFullInfo={false} isEdit={false}/>
        </Pane>
    );
}